import { render, staticRenderFns } from "./UserRequests.vue?vue&type=template&id=03022962&scoped=true&"
import script from "./UserRequests.vue?vue&type=script&lang=js&"
export * from "./UserRequests.vue?vue&type=script&lang=js&"
import style0 from "./UserRequests.vue?vue&type=style&index=0&id=03022962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03022962",
  null
  
)

export default component.exports